// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-ManagementPage-RolesTab-forms-RoleObjectField-RoleActionFields-RoleActionFields-module__checkboxGroup--upMmm {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.src-pages-ManagementPage-RolesTab-forms-RoleObjectField-RoleActionFields-RoleActionFields-module__title--ZWxtf {
  font-weight: 500;
}
.src-pages-ManagementPage-RolesTab-forms-RoleObjectField-RoleActionFields-RoleActionFields-module__container--oPahH .ant-form-item-control-input-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ManagementPage/RolesTab/forms/RoleObjectField/RoleActionFields/RoleActionFields.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;AAEA;EACE,gBAAA;AAAF;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADF","sourcesContent":[".checkboxGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.title {\n  font-weight: 500;\n}\n\n.container :global(.ant-form-item-control-input-content) {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkboxGroup": `src-pages-ManagementPage-RolesTab-forms-RoleObjectField-RoleActionFields-RoleActionFields-module__checkboxGroup--upMmm`,
	"title": `src-pages-ManagementPage-RolesTab-forms-RoleObjectField-RoleActionFields-RoleActionFields-module__title--ZWxtf`,
	"container": `src-pages-ManagementPage-RolesTab-forms-RoleObjectField-RoleActionFields-RoleActionFields-module__container--oPahH`
};
export default ___CSS_LOADER_EXPORT___;
